// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"b197e838","192":"b27e2e53","239":"780a8dd3","455":"f5e1d8d2","977":"9867d6b4"}[chunkId] + ".chunk.js";
};